var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('section-sidebar',{model:{value:(_vm.sections),callback:function ($$v) {_vm.sections=$$v},expression:"sections"}}),_c('b-col',{staticClass:"mt-3 mb-3",attrs:{"cols":"12","md":"9","xl":"10"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }